import { useAuth } from '../../hooks/useAuth';
import { useIdleTimeout } from '../../hooks/useIdleTimeout';

/**
 * Component that handles idle timeout detection.
 * Must be placed inside AuthProvider to access authentication state.
 * Automatically logs out user after configured period of inactivity.
 */
export function IdleTimeoutHandler() {
  const { isAuthenticated, logout } = useAuth();

  useIdleTimeout({
    isAuthenticated,
    onSessionExpire: logout,
  });

  // This component doesn't render anything
  return null;
}
